export default "__VITE_ASSET__ac40587a__"